import axios from 'axios';

import cfac22 from '../cfac22';

export default function readNotification(uId, id) {
  return new Promise((resolve, reject) => {
    Promise.resolve().
    then(() => {
      axios.
      post(
        `${cfac22('API_HOST_V2')}/notification/read`,
        {
          uId,
          id
        },
        { headers: { 'Full-Url': window.location.href }, withCredentials: true }
      ).
      then((result) => {
        // console.log('result_readNotification: ', result);
        resolve(result.data);
      }).
      catch((error) => {
        // console.log('error_readNotification: ', error);
        return reject(error);
      });
    }).
    catch((error) => {
      //console.log("ERROR_TOKEN:", error);
      reject(error);
    });
  });
}
